<template>
    <div class="new-certity-result-wrapper">
        <div class="line-top"></div>
        <div class="pc-result-main">
            <div class="certify-head-con">
                <div class="head-main-con">
                    <div class="left-logo">
                        <img src="~/assets/images/query/cflp-logo.png" alt="" />
                        <span class="sp-text">全国统一联网查询</span>
                    </div>
                    <!-- <div class="top-btn">
                        <router-link :to="{ name: 'xHome' }">
                            <i class="wl-icon-fanhui2"></i>
                            返回主站
                        </router-link>
                    </div> -->
                </div>
            </div>
            <div class="query-main-con">
                <div class="query-menu-con">
                    <i class="wl-icon-weibiaoti1"></i>
                    <span @click="toHome" class="sp-to-home">首页</span>
                    <span class="sp-lable-line">></span>
                    <span class="sp-active-label">证书查询</span>
                </div>
                <div class="step-main-con">
                    <el-steps :active="activeIndex" class="active-step-con">
                        <el-step title="输入条件查询" icon="wl-icon-kaoshixiangmu"></el-step>
                        <el-step title="选择证书列表" icon="wl-icon-chaxun2"></el-step>
                        <el-step :title="certifyTitle" :icon="typeIcon"></el-step>
                    </el-steps>
                    <div class="step-all-con">
                        <div v-if="activeIndex == 1" class="step-one-con">
                            <div class="step-title-con">
                                <i class="wl-icon-xiaoyuan"></i>
                                输入条件查询
                            </div>
                            <div class="search-form-con">

                                <el-form ref="form" :model="form" label-width="100px" class="form-input-con">
                                    <p class="input-tip-val">证书编号、姓名、和身份证件号码至少输入两项</p>
                                    <el-form-item label="姓名：" prop="name">
                                        <el-input v-model="form.name"></el-input>
                                    </el-form-item>

                                    <el-form-item label="身份证号：" prop="IDNuber"
                                        v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                        <el-input v-model="form.IDNuber"></el-input>
                                    </el-form-item>


                                    <el-form-item label="证书编号：" prop="cerfityNum"
                                        v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                        <el-input v-model="form.cerfityNum"></el-input>
                                    </el-form-item>

                                    <el-form-item>
                                        <el-button type="primary" @click="queryBtn"
                                            class="query-result-btn">查询</el-button>
                                        <el-button @click="resetForm()" class="reset-form-btn">重填</el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                        <div v-if="activeIndex == 2" class="step-one-con">
                            <div class="step-title-con">
                                <i class="wl-icon-xiaoyuan"></i>
                                选择证书列表
                            </div>
                            <div class="search-form-con">
                                <el-table :data="infoList" tooltip-effect="dark">
                                    <el-table-column label="序号" type="index"></el-table-column>
                                    <el-table-column prop="StudentName" label="姓名"></el-table-column>
                                    <el-table-column prop="IdCard" label="身份证号"></el-table-column>
                                    <el-table-column prop="CertificateType" label="证书类型"></el-table-column>
                                    <el-table-column prop="CertificateNum" label="证书编号"></el-table-column>
                                    <el-table-column prop="DateofIssue" label="颁证时间"></el-table-column>
                                    <el-table-column prop="CertificateUrl" label="电子证书">
                                        <template slot-scope="scope">
                                            <img style="height: 60px" :src="scope.row.CertificateUrl"
                                                @click="clickImg(scope.row.CertificateUrl)" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="effectiveTime" label="照片">
                                        <template slot-scope="scope">
                                            <img :src="scope.row.StudentUrl" height="50" width="50"
                                                v-if="scope.row.StudentUrl" />
                                            <img src="/static/img/default_avatar3.24690a70.png" height="50" width="50"
                                                v-else />
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作">
                                        <template slot-scope="scope">
                                            <el-button size="mini" type="primary"
                                                @click="goInfoMian(scope.row)">详情</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div class="guide-search-main">
                                <div class="grade-search-con clearfix">
                                    <div class="fr care-way-con care-way-con-wide">
                                        <div class="clearfix">
                                            <div class="icon-head-con head-con-2 fl">
                                                <i class="wl-icon-exclamation"></i>
                                            </div>
                                            <span class="sp-label-title fl">注意事项</span>
                                        </div>
                                        <p class="p-care-con">全国成绩/证书联网查询系统仅限于查询中国物流与采购联合会、北京中物联物流采购培训中心颁发的物流、采购及供应链相关证书;电子证书将于成绩公布之日起一周后开放查询及下载；纸质证书将于电子证书公示后二十天左右开始陆续邮寄。如有其他问题，请致电：<span class="sp-care-phone">010-83775917</span>。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="pc-node" v-if="activeIndex == 3" :class="['step-one-con']">
                            <div class="step-title-con">
                                <i class="wl-icon-xiaoyuan"></i>
                                {{ certifyName }}-查询结果
                            </div>
                            <!-- 暂时只展示 物流管理职业技能等级证书 证书模板 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'wbkraxarnlxhf8lvk6cumg'">
                                <!-- <canvas class="canvas" width="900px" height="650px" id="canvas"></canvas> -->
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                            </div>

                            <!--  物流管理职业技能等级证书（1+X）师资证书 证书模板 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'l53xabuser1ooa0kfxaya'">
                                <!-- <canvas class="canvas" width="900px" height="650px" id="canvas"></canvas> -->
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>

                            <!--  供应链运营职业技能等级证书（1+X）师资证书 证书模板 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'lran6tolracco2h7z6zq'">
                                <!-- <canvas class="canvas" width="900px" height="650px" id="canvas"></canvas> -->
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!--  结业证 证书模板 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'gmvapotmzblotynn168gw'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!--  青年结业证 证书模板 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'rguaafmtq6jfuw0iiiafg'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />

                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!--  课题申报结业证 证书模板 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'pmgvaceu44nmctfaabxgyg'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />

                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 全国高校骨干教师“数字供应链发展与供应链专业建设”专项能力提升高级研修班结业证书 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'h0yladouxqrgsv5omdjtq'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />

                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 职业院校物流专业“双师双证”骨干教师专业技能线上系列培训班结业证书 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'ayjadoubpjcm1sldjaytw'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />

                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 广西职业技术学院现代物流管理专业现代项目—上海顶实仓储有限公司广州分公司 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'kywvarkveytklrfskrgang'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />

                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 广西职业技术学院现代物流管理专业现代项目—南宁景通物流有限公司 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'pvosarkvg4fcfev2eocc3a'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />

                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 叉车设备 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'ebiaemv84tkgzwdec8seg'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 教师信息 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'slphapivsarmkha2px3pjg'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 供应链运营1+X书证融通结业证书 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'p64cavkwzoxbpbky8uxfka'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 物流管理1+X书证融通结业证书 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'pzqcavkw6q5d44rxqrnn0q'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 全国职业院校教师“智慧物流发展与专业建设”专项能力提升高级研修班结业证书 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'noq7agawtirdkomwpqw0bq'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 高校骨干教师“采购管理专业建设”专项能力提升高级研修班 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'gz2daloweybcoltmui3la'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'yyimamswnifpemkox1wklg'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 第六届青年教师 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'ig2ammwjjbmlxc7sd8efg'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 岗课 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'qkjiangw6jlhx0o7eiumya'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 专业技术 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'pzoxaeuwb5blp0oa0bdrjg'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == '7b8xaeuwfy9izcagbz7l9q'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'jstrahexozplsxtit0xj2w'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'cr3haegytavamugl0khw5w'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'qqvzaiy2ovmhkxjfokaea'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'iejyaiy3ztmssmfiauuw'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'bmuvakyy4j9cjiwtlhfh2q'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'ohoxakyyllpcepyjaadayw'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <div class="canvas-main-con"
                                v-if="type == 3 && (certifyId == 'j7yxakyyllvj7qpdl8ikpa' || certifyId == 'cw6gamqy96rhjei64itm0a' || certifyId == 'iscgamqyx6dalmwintsqga' || certifyId == 'cw6gamqy96rhjei64itm0a' || certifyId == 'elogab2zixb1ow0i6fa9w' || certifyId == 'luq1adez74rdbxynexpybw' || certifyId == '2wv9adzbpxbthk4ybxj0q')">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>


                            <!-- 学生证书 -->

                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'z733an6u3kfcxul99vd5a'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="650px" height="900px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <el-button class="continue-to-btn" style="margin-left: 50px"
                                    v-if="stuInfo.certificateUrl != ''"
                                    @click="downloadCertstu(stuInfo.downloadUrl)">下载高清版证书</el-button>

                            </div>
                            <!-- 采购师 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'eij3an6uszpixc6vt975ea'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="650px" height="900px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <el-button class="continue-to-btn" style="margin-left: 50px"
                                    v-if="stuInfo.certificateUrl != ''"
                                    @click="downloadCertstu(stuInfo.downloadUrl)">下载高清版证书</el-button>

                            </div>

                            <!-- 采购师 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == '0fynarqzaz5evqpakuw43a'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="650px" height="900px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <el-button class="continue-to-btn" style="margin-left: 50px"
                                    v-if="stuInfo.certificateUrl != ''"
                                    @click="downloadCertstu(stuInfo.downloadUrl)">下载高清版证书</el-button>

                            </div>

                                       <!-- 卡车司机运维员 -->
                                       <div class="canvas-main-con" v-if="type == 3 && certifyId == 'bowradezb4flpqu6nctzrw'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="650px" height="900px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <el-button class="continue-to-btn" style="margin-left: 50px"
                                    v-if="stuInfo.certificateUrl != ''"
                                    @click="downloadCertstu(stuInfo.downloadUrl)">下载高清版证书</el-button>

                            </div>

                            <!-- 物流职业经理 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'kqiahmrorrcurlncm3h9q'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 供应链管理师 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == '4lc1accv66bdbuvnmhovpq'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="650px" height="800px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <el-button class="continue-to-btn" style="margin-left: 50px"
                                    v-if="stuInfo.certificateUrl != ''"
                                    @click="downloadCertstu(stuInfo.downloadUrl)">下载高清版证书</el-button>
                            </div>
                            <!-- 合格证书 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'afioaxsvpl1bydz0rxzayg'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 全国院校“双师双证”骨干教师 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'qwtianix7rdkbwkeen5xra'">
                                <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                                    class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a> -->
                            </div>
                            <!-- 2024年高校骨干教师“数字供应链发展与供应链专业建设”专项能力 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'a0roanix5ydbscf2weoiva'">
                                <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                                    class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a> -->
                            </div>
                            <!-- 数字化仓库经理人证书 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'owgrawgwsaphvju6bvzzxw'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px"
                                    :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                                    头像未上传，无法生成在线证书，请联系管理员。</p>
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <div class="canvas-main-cons" v-if="type == 3 && certifyId == 'cmikalcuwyvf2xg1bebsq'">
                                <img class="exam-cover-img" :src="stuInfo.certificateUrl" alt="" />
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <div class="canvas-main-con" v-if="shouldShowGenericCertificate(false)">
                                <img @click="imgPreview(stuInfo.certificateUrl)" class="canvas generic-certificate-img"
                                    :src="stuInfo.certificateUrl" />
                                <a v-if="stuInfo.downloadUrl" class="continue-to-btn"
                                    :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <div class="basic-info-con" v-if="type == 3">
                                <div class="info-head-con">
                                    <i class="wl-icon-jibenxinxi"></i>
                                    <span>基本信息</span>
                                    <span class="small-title-con">/Basic Information</span>
                                </div>
                                <div class="clearfix c-info-main">
                                    <div class="fl c-info-item c-info-item-label">姓名：</div>
                                    <div class="fl c-info-item c-info-item-val">
                                        {{ stuInfo.studentName }}
                                    </div>
                                    <div class="fl c-info-item c-info-item-label">性别：</div>
                                    <div class="fl c-info-item c-info-item-val">
                                        {{ stuInfo.sex === 0 ? "男" : "女" }}
                                    </div>
                                    <div class="fl c-info-item c-info-item-label"
                                        v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">身份证号：</div>
                                    <div class="fl c-info-item c-info-item-val"
                                        v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                        {{ stuInfo.idCard }}
                                    </div>
                                    <div class="fl c-info-item c-info-item-label" v-if="stuInfo.type == 1">所在单位：</div>
                                    <div class="fl c-info-item c-info-item-val" v-if="stuInfo.type == 1">
                                        {{ stuInfo.schoolName }}
                                    </div>
                                    <div class="fl c-info-item c-info-item-label" v-if="stuInfo.type == 0">考核站点：</div>
                                    <div class="fl c-info-item c-info-item-val" v-if="stuInfo.type == 0">
                                        {{ stuInfo.siteName }}
                                    </div>
                                </div>
                                <div class="info-head-con">
                                    <i class="wl-icon-zhengshu"></i>
                                    <span>证书信息</span>
                                    <span class="small-title-con">/Certificate information</span>
                                </div>
                                <div class="clearfix c-info-main">
                                    <div
                                        v-if="certifyId != 'gmvapotmzblotynn168gw' && certifyId != 'rguaafmtq6jfuw0iiiafg' && certifyId != 'pmgvaceu44nmctfaabxgyg'">
                                        <div class="fl c-info-item c-info-item-label">证书等级：</div>
                                        <div class="fl c-info-item c-info-item-val">
                                            {{ stuInfo.examinationGrade }}
                                        </div>
                                    </div>

                                    <div class="fl c-info-item c-info-item-label">证书编号：</div>
                                    <div class="fl c-info-item c-info-item-val">
                                        {{ stuInfo.certificateNum }}
                                    </div>
                                    <div class="fl c-info-item c-info-item-label">发证机构：</div>
                                    <div class="fl c-info-item c-info-item-val"
                                        v-if="certifyId == 'wbkraxarnlxhf8lvk6cumg' || certifyId == 'w6uuasguqlpclawd9xb88g'">
                                        北京中物联物流采购培训中心</div>
                                    <div class="fl c-info-item c-info-item-val"
                                        v-else-if="certifyId == 'cmikalcuwyvf2xg1bebsq'">
                                        国际采购与供应管理联盟（IFPSM）</div>
                                    <div class="fl c-info-item c-info-item-val" v-else>
                                        {{ stuInfo.awardingUnit }}
                                    </div>
                                    <div class="fl c-info-item c-info-item-label">发证日期：</div>
                                    <div class="fl c-info-item c-info-item-val">
                                        {{ stuInfo.dateofIssue }}
                                    </div>
                                </div>
                            </div>

                            <!-- 成绩 -->
                            <el-table :data="gradeList" class="result-table-con" v-if="type == 2">
                                <el-table-column prop="studentName" label="姓名"></el-table-column>
                                <el-table-column prop="idCard" label="身份证号" width="180"
                                    v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'"></el-table-column>
                                <el-table-column prop="siteName" label="考点"></el-table-column>
                                <el-table-column prop="examTime" label="考试时间"></el-table-column>
                                <el-table-column prop="qualifiedState" label="考试结果"></el-table-column>
                                <el-table-column prop="score" label="考试成绩"></el-table-column>
                            </el-table>
                            <div class="continue-to-query">
                                <el-button class="continue-to-btn" @click="activeIndex = 2">返回上一步</el-button>
                                <el-button class="continue-to-btn" @click="continueBtn">继续查询</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="wl-index-footer-content">
                <div class="index-footer-con clearfix">
                    <div class="fl company-footer-info">
                        <div class="clearfix">
                            <div class="company-footer-logo-con">
                                <img src="~/assets/images/clpp-logo-white.png" alt class="ph-footer-logo-img" />
                            </div>
                        </div>
                        <!-- <div class="btn-contacts-number clearfix"> -->
                        <p class="p-footer-1">
                            <i class="wl-icon-dingwei"></i>
                            <span class="sp-info-label">地址：北京市丰台区丽泽路16号院2号楼铭丰大厦1106室</span>
                            <i class="wl-icon-tubiao209"></i>
                            <span class="sp-info-label">邮编：100079</span>
                            <i class="wl-icon-tubiao209"></i>
                            <span class="sp-info-label">邮箱： x@clpp.org.cn</span>
                        </p>
                        <!-- </div> -->
                        <p class="p-footer-2">
                            <span>Copyright 版权所有 ©</span>
                            <span class="sp-info-label">北京中物联物流采购培训中心</span>
                            <span>备案号：</span>
                            <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备19032250号-1</a>
                        </p>
                    </div>
                    <div class="fr company-footer-code-con clearfix">
                        <!-- <div class="fl f-code-img-con">
                            <img :src="footImage" alt class="f-code-img">
                            <p class="f-code-name">中物联教育培训</p>
                            </div>-->
                        <div class="fr f-code-img-con f-code-img-con-1">
                            <img src="~/assets/images/qrcode.png" alt class="f-code-img" />
                            <p class="f-code-name">中物联教育培训公众号</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 移动端 -->
        <div class="ph-result-main">
            <div class="certify-head-con">
                <div class="left-logo">
                    <img src="~/assets/images/query/cflp-logo.png" alt="" />
                    <span class="sp-text">全国统一联网查询</span>
                </div>
                <!-- <div class="top-btn">
					<router-link :to="{ name: 'xHome' }">
						<i class="wl-icon-fanhui2"></i>
						返回主站
					</router-link>
				</div> -->
            </div>
            <div class="ph-nav-con">
                <i class="wl-icon-weibiaoti1"></i>
                <span @click="toHome" class="sp-to-home">首页</span>
                <span class="sp-lable-line">></span>
                <span class="sp-active-label">证书查询</span>
            </div>
            <div class="ph-step-main">
                <el-steps :active="activeIndex" class="active-step-con">
                    <el-step title="输入条件查询" icon="wl-icon-kaoshixiangmu"></el-step>
                    <el-step title="选择证书列表" icon="wl-icon-chaxun2"></el-step>
                    <el-step :title="certifyTitle" :icon="typeIcon"></el-step>
                </el-steps>
            </div>
            <div class="ph-step-all-con">
                <div class="ph-step-one-con ph-step-1" v-if="activeIndex == 1">
                    <div class="step-head-con">
                        <i class="wl-icon-xiaoyuan"></i>
                        输入条件查询
                    </div>
                    <div class="ph-search-form-con">
                        <el-form ref="form" :model="form" label-width="85px" class size="small">
                            <p class="input-tip-val">证书编号、姓名、和身份证件号码至少输入两项</p>
                            <el-form-item label="姓名：" prop="name">
                                <el-input v-model="form.name"></el-input>
                            </el-form-item>

                            <el-form-item label="身份证号：" prop="IDNuber" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                <el-input v-model="form.IDNuber"></el-input>
                            </el-form-item>

                            <el-form-item label="证书编号：" prop="cerfityNum" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                <el-input v-model="form.cerfityNum"></el-input>
                            </el-form-item>

                            <el-form-item>
                                <el-button type="primary" @click="queryBtn" class="query-result-btn">查询</el-button>
                                <el-button @click="resetForm()" class="reset-form-btn">重填</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="ph-step-one-con ph-step-2" v-if="activeIndex == 2">
                    <div class="step-head-con">
                        <i class="wl-icon-xiaoyuan"></i>
                        {{ certifyName }}-输入查询条件
                    </div>
                    <div class="ph-search-form-con">
                        <el-table :data="infoList" tooltip-effect="dark">
                            <el-table-column label="序号" type="index"></el-table-column>
                            <el-table-column prop="CertificateType" label="证书类型"></el-table-column>
                            <el-table-column prop="CertificateNum" label="证书编号"></el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button size="mini" type="primary" @click="goInfoMian(scope.row)">详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div id="my-node" :class="['ph-step-one-con ph-step-3']" v-if="activeIndex == 3">
                    <div class="step-head-con">
                        <i class="wl-icon-xiaoyuan"></i>
                        {{ certifyName }}-查询结果
                    </div>

                    <!--  物流管理职业技能等级证书（1+X）师资证书 证书模板 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == 'l53xabuser1ooa0kfxaya'">
                        <!-- <canvas class="canvas" width="900px" height="650px" id="canvas"></canvas> -->
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />
                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                        <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                        <!-- <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a> -->
                    </div>

                    <!--  供应链运营职业技能等级证书（1+X）师资证书 证书模板 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == 'lran6tolracco2h7z6zq'">
                        <!-- <canvas class="canvas" width="900px" height="650px" id="canvas"></canvas> -->
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />
                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                        <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                        <!-- <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a> -->
                    </div>
                    <!--  结业证 证书模板 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == 'gmvapotmzblotynn168gw'">
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />
                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                        <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                        <!-- <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a> -->
                    </div>
                    <!--  青年结业证 证书模板 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == 'rguaafmtq6jfuw0iiiafg'">
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />

                        <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                        <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                        <!-- <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a> -->
                    </div>
                    <!--  课题申报结业证 证书模板 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == 'pmgvaceu44nmctfaabxgyg'">
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />

                        <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                        <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                        <!-- <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a> -->
                    </div>
                    <!-- 全国高校骨干教师“数字供应链发展与供应链专业建设”专项能力提升高级研修班结业证书 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == 'h0yladouxqrgsv5omdjtq'">
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />

                        <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                        <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                        <!-- <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a> -->
                    </div>
                    <!-- 职业院校物流专业“双师双证”骨干教师专业技能线上系列培训班结业证书 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == 'ayjadoubpjcm1sldjaytw'">
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />

                        <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                        <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                        <!-- <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a> -->
                    </div>
                    <!-- 广西职业技术学院现代物流管理专业现代项目—上海顶实仓储有限公司广州分公司 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == 'kywvarkveytklrfskrgang'">
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />

                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>

                    </div>
                    <!-- 广西职业技术学院现代物流管理专业现代项目—南宁景通物流有限公司 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == 'pvosarkvg4fcfev2eocc3a'">
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />

                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                        <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                        <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn"
                            :href="stuInfo.downloadUrl">下载证书</a>
                    </div>
                    <!-- 叉车设备 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == 'ebiaemv84tkgzwdec8seg'">
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />
                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                    </div>
                    <!-- 学生证书 -->
                    <!--  物流管理职业技能等级证书 证书模板 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == 'wbkraxarnlxhf8lvk6cumg'">
                        <!-- <canvas class="canvas" width="900px" height="650px" id="canvas"></canvas> -->
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="100%" :src="stuInfo.certificateUrl" />
                    </div>
                    <!-- 物流师 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == 'z733an6u3kfcxul99vd5a'">
                        <!-- <canvas class="canvas" width="900px" height="650px" id="canvas"></canvas> -->
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="650px" height="900px" :src="stuInfo.certificateUrl" />
                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                        <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                        <!-- <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a> -->
                    </div>
                    <!-- 采购师 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == 'eij3an6uszpixc6vt975ea'">
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="650px" height="900px" :src="stuInfo.certificateUrl" />
                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                        <!-- <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a> -->
                    </div>

                    <!-- 碳排放管理师 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == '0fynarqzaz5evqpakuw43a'">
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="650px" height="900px" :src="stuInfo.certificateUrl" />
                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                        <!-- <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a> -->
                    </div>


                         <!-- 卡车运维管理师 -->
                         <div class="canvas-main-con" v-if="certifyId == 'bowradezb4flpqu6nctzrw'">
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="650px" height="900px" :src="stuInfo.certificateUrl" />
                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                        <!-- <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a> -->
                    </div>

                    <!-- 物流职业经理 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == 'kqiahmrorrcurlncm3h9q'">
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />
                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                        <!-- <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a> -->
                    </div>
                    <!-- 供应链管理师 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == '4lc1accv66bdbuvnmhovpq'">
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />
                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                        <!-- <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a> -->
                    </div>
                    <!-- 国际换证 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == 'cmikalcuwyvf2xg1bebsq'">
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="650px" height="900px" :src="stuInfo.certificateUrl" />
                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                    </div>
                    <!-- 全国院校“双师双证”骨干教师 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == 'qwtianix7rdkbwkeen5xra'">
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />
                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                        <!-- <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a> -->
                    </div>
                    <!-- 2024年高校骨干教师“数字供应链发展与供应链专业建设”专项能力 -->
                    <div class="canvas-main-con"
                        v-if="type == 3 && (certifyId == 'a0roanix5ydbscf2weoiva' || certifyId == 'elogab2zixb1ow0i6fa9w' || certifyId == 'luq1adez74rdbxynexpybw' || certifyId == '2wv9adzbpxbthk4ybxj0q')">
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />
                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                        <!-- <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a> -->
                    </div>
                    <!-- 合格证书 -->
                    <div class="canvas-main-con" v-if="type == 3 && certifyId == 'afioaxsvpl1bydz0rxzayg'">
                        <img @click="imgPreview(stuInfo.certificateUrl)" v-if="stuInfo.certificateUrl != ''"
                            class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />
                        <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">
                            头像未上传，无法生成在线证书，请联系管理员。</p>
                        <!-- <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a> -->
                    </div>
                    <div class="canvas-main-con" v-if="shouldShowGenericCertificate(true)">
                        <img @click="imgPreview(stuInfo.certificateUrl)" class="canvas generic-certificate-img"
                            :src="stuInfo.certificateUrl" />
                        <a v-if="stuInfo.downloadUrl" class="continue-to-btn"
                            :href="stuInfo.downloadUrl">下载证书</a>
                    </div>

                    <div v-if="type == 3 && certifyId == 'wbkraxarnlxhf8lvk6cumg'" class="cerfity-img-con">
                        <img :src="certificate" alt />
                    </div>
                    <div class="basic-info-con" v-if="type == 3">
                        <div class="info-head-con">
                            <i class="wl-icon-jibenxinxi"></i>
                            <span>基本信息</span>
                            <span class="small-title-con">/Basic Information</span>
                        </div>
                        <div class="clearfix c-info-main">
                            <div class="fl c-info-item c-info-item-label">姓名：</div>
                            <div class="fl c-info-item c-info-item-val">
                                {{ stuInfo.studentName }}
                            </div>
                            <div class="fl c-info-item c-info-item-label">性别：</div>
                            <div class="fl c-info-item c-info-item-val">
                                {{ stuInfo.sex === 0 ? "男" : "女" }}
                            </div>
                            <div class="fl c-info-item c-info-item-label" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                身份证号：
                            </div>
                            <div class="fl c-info-item c-info-item-val" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                {{ stuInfo.idCard }}
                            </div>
                            <div class="fl c-info-item c-info-item-label" v-if="stuInfo.type == 1">所在单位：</div>
                            <div class="fl c-info-item c-info-item-val" v-if="stuInfo.type == 1">
                                {{ stuInfo.schoolName }}
                            </div>
                            <div class="fl c-info-item c-info-item-label" v-if="stuInfo.type == 0">考核站点：</div>
                            <div class="fl c-info-item c-info-item-val" v-if="stuInfo.type == 0">
                                {{ stuInfo.siteName }}
                            </div>
                        </div>
                        <div>
                            <div class="info-head-con">
                                <i class="wl-icon-zhengshu"></i>
                                <span>证书信息</span>
                                <span class="small-title-con">/Certificate information</span>
                            </div>
                            <div class="clearfix c-info-main">
                                <div
                                    v-if="certifyId != 'gmvapotmzblotynn168gw' && certifyId != 'rguaafmtq6jfuw0iiiafg' && certifyId != 'pmgvaceu44nmctfaabxgyg'">
                                    <div class="fl c-info-item c-info-item-label">证书等级：</div>
                                    <div class="fl c-info-item c-info-item-val">
                                        {{ stuInfo.examinationGrade }}
                                    </div>
                                </div>

                                <div class="fl c-info-item c-info-item-label">证书编号：</div>
                                <div class="fl c-info-item c-info-item-val">
                                    {{ stuInfo.certificateNum }}
                                </div>
                                <div class="fl c-info-item c-info-item-label">发证机构：</div>
                                <div class="fl c-info-item c-info-item-val"
                                    v-if="certifyId == 'wbkraxarnlxhf8lvk6cumg'">
                                    北京中物联物流采购培训中心</div>
                                <div class="fl c-info-item c-info-item-val"
                                    v-else-if="certifyId == 'cmikalcuwyvf2xg1bebsq'">
                                    国际采购与供应管理联盟（IFPSM）</div>
                                <div class="fl c-info-item c-info-item-val" v-else>
                                    {{ stuInfo.awardingUnit }}
                                </div>
                                <div class="fl c-info-item c-info-item-label">发证日期：</div>
                                <div class="fl c-info-item c-info-item-val">
                                    {{ stuInfo.dateofIssue }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="result-table-main">
                        <el-table :data="gradeList" class="result-table-con" v-if="type == 2" size="small">
                            <el-table-column fixed prop="studentName" label="姓名"></el-table-column>
                            <el-table-column prop="idCard" label="身份证号" width="180"
                                v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'"></el-table-column>
                            <el-table-column prop="siteName" label="考点"></el-table-column>
                            <el-table-column prop="examTime" label="考试时间"></el-table-column>
                            <el-table-column prop="qualifiedState" label="考试结果"></el-table-column>
                            <el-table-column prop="score" label="考试成绩"></el-table-column>
                        </el-table>
                    </div>
                    <div class="continue-to-query">
                        <el-button class="continue-to-btn" size="small" @click="activeIndex = 2">返回上一步</el-button>
                        <el-button class="continue-to-btn" size="small" @click="continueBtn">继续查询</el-button>
                    </div>
                </div>
            </div>
            <div class="ph-index-footer-content">
                <div class="index-footer-con clearfix">
                    <div class="company-footer-info">
                        <!-- <div class="company-footer-logo-con">
                            <img :src="footerLogo" alt>
                            </div>-->
                        <p class="p-footer-1">
                            <i class="wl-icon-dingwei"></i>
                            <span class="sp-info-label">地址：北京市丰台区丽泽路16号院2号楼铭丰大厦1106室</span>
                        </p>
                        <p class="p-footer-2">
                            <i class="wl-icon-tubiao209"></i>
                            <span class="sp-info-label">邮编：100079</span>
                        </p>
                        <p class="p-footer-2">
                            <i class="wl-icon-tubiao209"></i>
                            <span class="sp-info-label">邮箱：x@clpp.org.cn</span>
                        </p>
                    </div>
                    <div class="company-footer-code-con clearfix">
                        <!-- <div class="f-code-img-con fl">
                        <img :src="footerLogo" alt class="f-code-img" />
                    </div> -->
                        <div class="f-code-img-con">
                            <img src="~/assets/images/qrcode.png" alt class="f-code-img" />
                            <p class>中物联教育培训公众号</p>
                        </div>
                    </div>
                    <p class="p-footer-3">
                        <span>Copyright 版权所有 ©</span>
                        <span class="sp-info-label">北京中物联物流采购培训中心</span>
                    </p>
                    <p class="p-footer-4">
                        <span>备案号：</span>
                        <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备19032250号-1</a>
                    </p>
                </div>
            </div>
        </div>
        <el-dialog title="在线证书展示" :modal="false" top="10px" :visible.sync="imageUrlShow" width="1280px">
            <div>
                <img :src="imageUrl" style="width: 1200px; height: 850px" />
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="imageUrlClose">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
    data() {
        return {
            certificateZXJYZ: require("assets/images/zxpxjyzh.jpg"),
            certificateJYZ: require("assets/images/certificateJYZ.jpg"),
            certificateQNJYZ: require("assets/images/qnjyz.jpg"),
            userActive: require("assets/images/person.png"),
            logo: require("assets/images/ce-qeury-logo.png"),
            activeIndex: 1,
            cerfityList: [],
            form: {
                level: "",
                cerfityNum: "",
                name: "",
                IDNuber: "",
                ZKZ_ID: "",
            },
            levelOption: [],
            certifyId: "",
            certifyName: "",
            isScoreGrade: "",
            isCertificateGrade: "",
            stuInfo: {},
            stuList: [],
            certificate: require("assets/images/certificate.png"),
            certificateWL: require("assets/images/certificateWL.jpg"), //物流管理
            certificateGYL: require("assets/images/certificateGYL.jpg"), //供应链运营
            dateMoth: ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"],
            dateGradeEnglish: [
                {
                    value: "物流员（仓储与配送）",
                    label: "Basic level(Warehousing&Distribution)",
                },
                {
                    value: "物流员（货物运输）",
                    label: "Basic level(Transport of goods)",
                },
                {
                    value: "助理级",
                    label: "Junior Level",
                },
                {
                    value: "初级",
                    label: "Primary Level",
                },
                {
                    value: "中级",
                    label: "Middle Level",
                },
                {
                    value: "高级",
                    label: "Senior Level",
                },
                {
                    value: "见习中级",
                    label: "Middle Level (Intern)",
                },
                // {
                //     value: "中级",
                //     label: "Middle Level.",
                // },
                // {
                //     value: "高级",
                //     label: "Senior Level.",
                // },
                {
                    value: "注册级",
                    label: "Registered  Level",
                },
            ],
            certifyUrl: "",
            certifyTitle: "",
            gradeList: [],
            typeIcon: "",
            infoList: [],
            imageUrlShow: false,
            imageUrl: "",
        };
    },
    props: {
        // 1 证书 2 成绩
        type: {
            type: [Number, String],
            default: "",
        },
    },
    computed: {
        auth() {
            let auth = this.$store.state.auth;
            return auth;
        },
    },
    mounted() {

    },
    created() {
        this.getCerfityList();
        this.certifyTitle = this.type == 3 ? "查看证书" : "查看成绩";
        this.typeIcon = this.type == 3 ? "wl-icon-zhengshu1" : "wl-icon-xuexichengji";
    },
    methods: {
        imgPreview(url) {
            if (url) {
                ImagePreview({ images: [url], closeable: true });
            }
        },
        continueBtn() {
            this.activeIndex = 1;
            this.resetForm();
        },
        clickImg(url) {
            if (this.auth.code < 0) return false;
            this.imageUrl = url;
            this.imageUrlShow = true;
        },

        imageUrlClose() {
            this.imageUrlShow = false;
        },
        shouldShowGenericCertificate(isMobile) {
            if (this.type != 3 || !this.stuInfo || !this.stuInfo.certificateUrl) {
                return false;
            }
            return this.getBuiltinCertificatePreviewIds(isMobile).indexOf(this.certifyId) < 0;
        },
        getBuiltinCertificatePreviewIds(isMobile) {
            if (isMobile) {
                return [
                    "l53xabuser1ooa0kfxaya", "lran6tolracco2h7z6zq", "gmvapotmzblotynn168gw",
                    "rguaafmtq6jfuw0iiiafg", "pmgvaceu44nmctfaabxgyg", "h0yladouxqrgsv5omdjtq",
                    "ayjadoubpjcm1sldjaytw", "kywvarkveytklrfskrgang", "pvosarkvg4fcfev2eocc3a",
                    "ebiaemv84tkgzwdec8seg", "wbkraxarnlxhf8lvk6cumg", "z733an6u3kfcxul99vd5a",
                    "eij3an6uszpixc6vt975ea", "0fynarqzaz5evqpakuw43a", "bowradezb4flpqu6nctzrw",
                    "kqiahmrorrcurlncm3h9q", "4lc1accv66bdbuvnmhovpq", "cmikalcuwyvf2xg1bebsq",
                    "qwtianix7rdkbwkeen5xra", "a0roanix5ydbscf2weoiva", "elogab2zixb1ow0i6fa9w",
                    "luq1adez74rdbxynexpybw", "2wv9adzbpxbthk4ybxj0q", "afioaxsvpl1bydz0rxzayg",
                ];
            }
            return [
                "wbkraxarnlxhf8lvk6cumg", "l53xabuser1ooa0kfxaya", "lran6tolracco2h7z6zq",
                "gmvapotmzblotynn168gw", "rguaafmtq6jfuw0iiiafg", "pmgvaceu44nmctfaabxgyg",
                "h0yladouxqrgsv5omdjtq", "ayjadoubpjcm1sldjaytw", "kywvarkveytklrfskrgang",
                "pvosarkvg4fcfev2eocc3a", "ebiaemv84tkgzwdec8seg", "slphapivsarmkha2px3pjg",
                "p64cavkwzoxbpbky8uxfka", "pzqcavkw6q5d44rxqrnn0q", "noq7agawtirdkomwpqw0bq",
                "gz2daloweybcoltmui3la", "yyimamswnifpemkox1wklg", "ig2ammwjjbmlxc7sd8efg",
                "qkjiangw6jlhx0o7eiumya", "pzoxaeuwb5blp0oa0bdrjg", "7b8xaeuwfy9izcagbz7l9q",
                "jstrahexozplsxtit0xj2w", "cr3haegytavamugl0khw5w", "qqvzaiy2ovmhkxjfokaea",
                "iejyaiy3ztmssmfiauuw", "bmuvakyy4j9cjiwtlhfh2q", "ohoxakyyllpcepyjaadayw",
                "j7yxakyyllvj7qpdl8ikpa", "cw6gamqy96rhjei64itm0a", "iscgamqyx6dalmwintsqga",
                "elogab2zixb1ow0i6fa9w", "luq1adez74rdbxynexpybw", "2wv9adzbpxbthk4ybxj0q",
                "z733an6u3kfcxul99vd5a", "eij3an6uszpixc6vt975ea", "0fynarqzaz5evqpakuw43a",
                "bowradezb4flpqu6nctzrw", "kqiahmrorrcurlncm3h9q", "4lc1accv66bdbuvnmhovpq",
                "afioaxsvpl1bydz0rxzayg", "qwtianix7rdkbwkeen5xra", "a0roanix5ydbscf2weoiva",
                "owgrawgwsaphvju6bvzzxw", "cmikalcuwyvf2xg1bebsq",
            ];
        },
        searchCerfity(id, isQuery, isScoreGrade, isCertificateGrade, label) {
            if (isQuery == "1") {
                return this.$message.warning("暂不可查询!");
            }
            this.certifyId = id;
            this.activeIndex = 2;
            this.isScoreGrade = isScoreGrade;
            this.isCertificateGrade = isCertificateGrade;
            this.certifyName = label;
            this.$http
                .post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
                    typeId: id,
                })
                .then((res) => {
                    if (res.code > 0) {
                        this.levelOption = res.list;
                    } else {
                        return;
                    }
                });
        },
        resetForm() {
            this.form.level = "";
            this.form.cerfityNum = "";
            this.form.name = "";
            this.form.IDNuber = "";
            this.form.ZKZ_ID = "";
            // this.$refs[formName].resetFields();
        },
        queryBtn() {
            var that = this;
            // 证书查询
            if (this.type == 3) {
                this.$http.post("/api/XOrg/CertificateManager/getTeacherCertificateInfo", {
                    idNum: this.form.IDNuber,
                    name: this.form.name,
                    cerfityNum: this.form.cerfityNum
                })
                    .then((rst) => {
                        if (rst.code > 0) {
                            this.infoList = rst.infoList;
                            this.activeIndex = 2
                        } else {
                            this.$message.warning(rst.msg);
                        }
                    });

                // this.$http
                //     .post("/api/XOrg/CertificateManager/getCertificateInfoList", {
                //         //getCertificateInfoList
                //         name: this.form.name,
                //         IDNum: this.form.IDNuber,
                //         cerfityNum: this.form.cerfityNum,
                //         ExaminationGradeId: this.form.level,
                //         CertificateTypeId: this.certifyId,
                //     })
                //     .then((res) => {
                //         if (res.code > 0) {
                //             that.stuInfo = res.info;
                //             that.peixunTime = res.peixunTime;
                //             that.peixunTimeMonths = res.peixunTimeMonths;
                //             that.peixunTimeMonthsa = res.peixunTimeMonthsa;
                //             that.activeIndex = 3;
                //             if (that.certifyId == "wbkraxarnlxhf8lvk6cumg") {
                //                 that.$nextTick(() => {
                //                     that.getCanvas();
                //                 });
                //             } else if (that.certifyId == "l53xabuser1ooa0kfxaya" && res.info.peixunTimeYear > 2020) {
                //                 //物流管理
                //                 that.$nextTick(() => {
                //                     that.getCanvasWL();
                //                 });
                //             } else if (that.certifyId == "lran6tolracco2h7z6zq" && res.info.peixunTimeYear > 2020) {
                //                 //供应链运营
                //                 that.$nextTick(() => {
                //                     that.getCanvasGYL();
                //                 });
                //             } else if (that.certifyId == "gmvapotmzblotynn168gw") {
                //                 //结业证
                //                 that.$nextTick(() => {
                //                     that.getCanvasJYZ();
                //                 });
                //             } else if (that.certifyId == "rguaafmtq6jfuw0iiiafg") {
                //                 //结业证
                //                 that.$nextTick(() => {
                //                     that.getCanvasQNJYZ();
                //                 });
                //             } else if (that.certifyId == "pmgvaceu44nmctfaabxgyg") {
                //                 //结业证
                //                 that.$nextTick(() => {
                //                     that.getCanvasZXJYZ();
                //                 });
                //             }
                //         } else {
                //             return this.$message.warning(res.msg);
                //         }
                //     });
            }
            if (this.type == 2) {
                this.$http
                    .post("/api/XOrg/ResultsManager/getStudentResultList", {
                        studentName: this.form.name,
                        idCard: this.form.IDNuber,
                        ExaminationGradeId: this.form.level,
                        CertificateTypeId: this.certifyId,
                        ZKZ_ID: this.form.ZKZ_ID,
                    })
                    .then((res) => {
                        if (res.code > 0) {
                            that.gradeList = res.list;
                            that.activeIndex = 3;
                        } else {
                            return this.$message.warning(res.msg);
                        }
                    });
            }
        },
        goInfoMian(data) {
            this.$http
                .post("/api/XOrg/CertificateManager/getCertificateInfoList", {
                    name: data.StudentName,
                    IDNum: data.IdCard,
                    cerfityNum: data.CertificateNum,
                    CertificateTypeId: data.CertificateTypeId,
                })
                .then((res) => {
                    if (res.code > 0) {
                        this.stuInfo = res.info;
                        this.peixunTime = res.peixunTime;
                        this.peixunTimeMonths = res.peixunTimeMonths;
                        this.peixunTimeMonthsa = res.peixunTimeMonthsa;
                        this.certifyId = data.CertificateTypeId;
                        this.activeIndex = 3;
                    } else {
                        return this.$message.warning(res.msg);
                    }
                });
        },
        getCanvas() {
            var canvas = document.getElementById("canvas");
            console.log(canvas);
            var ctx = canvas.getContext("2d");
            // 绘制背景图
            var image1 = new Image();
            image1.src = this.certificate;
            var promise1 = new Promise((resolve, reject) => {
                image1.onload = function () {
                    ctx.drawImage(image1, 0, 0, 900, 650);
                    resolve("ok");
                };
            });
            promise1
                .then((res) => {
                    if (res == "ok") {
                        // 学生姓名
                        ctx.font = "14px Arial"; //宋体
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.studentName}`, 730, 340);
                        ctx.stroke();
                        // 学生姓名（拼音）
                        ctx.font = "14px Arial";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.studentNamePinyin}`, 710, 370);
                        ctx.stroke();
                        // 参加物流考试时间
                        ctx.font = "16px Source Han Sans CN";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.examTime}`, 145, 198);
                        // 级别（初级 中级 高级）
                        ctx.font = "16px Source Han Sans CN";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.examinationGrade}`, 359, 228);
                        // 参加物流考试的时间（英文）
                        ctx.font = "italic 12px Arial";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`in ${this.stuInfo.examYMEnglish}`, 555, 285);
                        // 级别（初级 中级 高级）（英文）
                        ctx.font = "italic 12px Arial";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.examinationGradeEnglish}`, 242, 313);
                        // 身份证
                        ctx.font = "16px Source Han Sans CN";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.idCard}`, 230, 380);
                        // 证书编号
                        ctx.font = "16px Source Han Sans CN";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.certificateNum}`, 230, 420);
                        // 发放证书时间
                        ctx.font = "16px Source Han Sans CN";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.dateofIssue}`, 230, 505);
                        var image = new Image();
                        image.setAttribute("crossOrigin", "Anonymous");
                        image.src = this.stuInfo.studentUrl;
                        image.onload = () => {
                            ctx.drawImage(image, 698, 190, 100, 130);
                            this.certifyUrl = canvas.toDataURL("image/jpeg");
                            console.log(this.certifyUrl);
                        };
                    }
                })
                .catch((err) => { });
        },
        getCanvasWL() {
            var canvas = document.getElementById("canvas");
            console.log(canvas);
            var ctx = canvas.getContext("2d");
            // 绘制背景图
            var image1 = new Image();
            image1.src = this.certificateWL;
            var promise1 = new Promise((resolve, reject) => {
                image1.onload = function () {
                    ctx.drawImage(image1, 0, 0, 900, 650);
                    resolve("ok");
                };
            });
            promise1.then((res) => {
                if (res == "ok") {
                    //考生照片
                    var promise2 = new Promise((r1, r2) => {
                        var img = new Image();
                        img.crossOrigin = "*";

                        img.src = this.stuInfo.studentUrl + "?v=" + Math.random();

                        img.onload = function () {
                            //ctx.drawImage(img, 412, 350, 95, 130);
                            ctx.drawImage(img, 210, 180, 95, 130);
                        };
                    });

                    // 上部年左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(0, 4)}`, 546, 160);
                    // 上部年右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(11, 15)}`, 685, 160);
                    // 中部年左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZx}`, 468, 305);
                    // 中部年右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZy}`, 620, 305);

                    // 下部年
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZ}`, 630, 525);

                    // 上部月左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(5, 7)}`, 596, 160);
                    // 上部月右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(16, 18)}`, 732, 160);
                    // 中部月左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZx}`, 520, 305);
                    // 中部月右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZy}`, 670, 305);
                    // 下部月
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZ}`, 695, 525);

                    // 上部日左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(8, 10)}`, 630, 160);
                    // 上部日右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(19, 21)}`, 767, 160);
                    // 中部日左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZx}`, 560, 305);
                    // 中部日右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZy}`, 710, 305);
                    // 下部日
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZ}`, 735, 525);

                    //英文日期发证时间
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.stuInfo.examTimeMonths]} ${this.stuInfo.examTimeDayFZ} ${this.stuInfo.examTimeYearFZ}`, 675, 545);

                    //英文日期培训时间开始
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.peixunTimeMonths]} ${this.peixunTime.slice(8, 10)}`, 710, 368);

                    //英文日期培训时间结束
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.peixunTimeMonthsa]} ${this.peixunTime.slice(19, 21)} ${this.stuInfo.examTimeYearFZa}`, 440, 385);

                    //英文日期聘期开始时间
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.stuInfo.examTimeMonthsb]} ${this.stuInfo.examTimeDayFZb} ${this.stuInfo.examTimeYearFZb}`, 720, 418);

                    //英文日期聘期结束时间
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.stuInfo.examTimeMonthsc]} ${this.stuInfo.examTimeDayFZc} ${this.stuInfo.examTimeYearFZc}`, 440, 435);

                    //学生姓名
                    ctx.font = "14px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studentName}`, 450, 160);
                    ctx.stroke();
                    // 学生姓名（拼音）
                    ctx.font = "12px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studentNamePinyin}`, 583, 332);
                    ctx.stroke();

                    // 身份证
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.idCard}`, 220, 452);
                    // 证书编号
                    ctx.font = "13px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.certificateNum}`, 220, 495);

                    // 学时上
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studyTime}`, 580, 230);
                    //学时下
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studyTimex}`, 600, 385);

                    // 级别（初级 中级 高级）
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examinationGrade}`, 470, 230);

                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examinationGradex}`, 730, 270);

                    //级别（初级 中级 高级）（英文）
                    ctx.font = "12px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    let str = this.dateGradeEnglish.find((item, index) => {
                        return item.value === this.stuInfo.examinationGrade;
                    });
                    ctx.fillText(`${str.label}`, 550, 368);

                    ctx.font = "12px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    let strx = this.dateGradeEnglish.find((item, index) => {
                        return item.value === this.stuInfo.examinationGradex;
                    });
                    ctx.fillText(`${strx.label}`, 600, 418);
                }
            });
        },
        getCanvasGYL() {
            var canvas = document.getElementById("canvas");
            console.log(canvas);
            var ctx = canvas.getContext("2d");
            // 绘制背景图
            var image1 = new Image();
            image1.src = this.certificateGYL;
            var promise1 = new Promise((resolve, reject) => {
                image1.onload = function () {
                    ctx.drawImage(image1, 0, 0, 900, 650);
                    resolve("ok");
                };
            });
            promise1.then((res) => {
                if (res == "ok") {
                    //考生照片
                    var promise2 = new Promise((r1, r2) => {
                        var img = new Image();
                        img.crossOrigin = "*";

                        img.src = this.stuInfo.studentUrl + "?v=" + Math.random();

                        img.onload = function () {
                            //ctx.drawImage(img, 412, 350, 95, 130);
                            ctx.drawImage(img, 210, 180, 95, 130);
                        };
                    });

                    // 上部年左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(0, 4)}`, 540, 160);
                    // 上部年右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(11, 15)}`, 681, 160);
                    // 中部年左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZx}`, 700, 270);
                    // 中部年右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZy}`, 497, 305);

                    // 下部年
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZ}`, 630, 525);

                    // 上部月左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(5, 7)}`, 592, 160);
                    // 上部月右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(16, 18)}`, 730, 160);
                    // 中部月左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZx}`, 770, 270);
                    // 中部月右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZy}`, 550, 305);
                    // 下部月
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZ}`, 692, 525);

                    // 上部日左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(8, 10)}`, 628, 160);
                    // 上部日右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(19, 21)}`, 766, 160);
                    // 中部日左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZx}`, 437, 305);
                    // 中部日右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZy}`, 591, 305);
                    // 下部日
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZ}`, 732, 525);

                    //英文日期发证时间
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.stuInfo.examTimeMonths]} ${this.stuInfo.examTimeDayFZ} ${this.stuInfo.examTimeYearFZ}`, 675, 545);

                    //英文日期培训时间开始
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.peixunTimeMonths]} ${this.peixunTime.slice(8, 10)}`, 580, 368);

                    //英文日期培训时间结束
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.peixunTimeMonthsa]} ${this.peixunTime.slice(19, 21)} ${this.stuInfo.examTimeYearFZa}`, 710, 368);

                    //英文日期聘期开始时间
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.stuInfo.examTimeMonthsb]} ${this.stuInfo.examTimeDayFZb} ${this.stuInfo.examTimeYearFZb}`, 475, 418);

                    //英文日期聘期结束时间
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.stuInfo.examTimeMonthsc]} ${this.stuInfo.examTimeDayFZc} ${this.stuInfo.examTimeYearFZc}`, 610, 418);

                    //学生姓名
                    ctx.font = "14px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studentName}`, 458, 160);
                    ctx.stroke();
                    // 学生姓名（拼音）
                    ctx.font = "12px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studentNamePinyin}`, 570, 332);
                    ctx.stroke();

                    // 身份证
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.idCard}`, 220, 452);
                    // 证书编号
                    ctx.font = "13px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.certificateNum}`, 220, 495);

                    // 学时上
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studyTimeg}`, 520, 230);
                    //学时下
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studyTimegx}`, 465, 385);

                    // 级别（初级 中级 高级）
                    // ctx.font = "14px  HYDaSongJ";
                    // ctx.fillStyle = "#1c1417";
                    // ctx.fillText(`${this.stuInfo.examinationGrade}`, 480, 230);

                    // ctx.font = "14px  HYDaSongJ";
                    // ctx.fillStyle = "#1c1417";
                    // ctx.fillText(`${this.stuInfo.examinationGradex}`, 745, 268);

                    //级别（初级 中级 高级）（英文）
                    // ctx.font = "12px HYDaSongJ";
                    // ctx.fillStyle = "#1c1417";
                    // let str = this.dateGradeEnglish.find((item, index) => {
                    //     return item.value === this.stuInfo.examinationGrade;
                    // });
                    // ctx.fillText(`${str.label}`, 550, 368);

                    // ctx.font = "12px HYDaSongJ";
                    // ctx.fillStyle = "#1c1417";
                    // let strx = this.dateGradeEnglish.find((item,index)=>{
                    //     return item.value === this.stuInfo.examinationGradex
                    // })
                    // ctx.fillText(`${strx.label}`, 540, 418);
                }
            });
        },
        getCanvasJYZ() {
            var canvas = document.getElementById("canvas");
            console.log(canvas);
            var ctx = canvas.getContext("2d");
            // 绘制背景图
            var image1 = new Image();
            image1.src = this.certificateJYZ;
            var promise1 = new Promise((resolve, reject) => {
                image1.onload = function () {
                    ctx.drawImage(image1, 0, 0, 900, 650);
                    resolve("ok");
                };
            });
            promise1.then((res) => {
                if (res == "ok") {
                    //考生照片
                    var promise2 = new Promise((r1, r2) => {
                        var img = new Image();
                        img.crossOrigin = "*";

                        img.src = this.stuInfo.studentUrl + "?v=" + Math.random();
                        // img.src = this.person;

                        img.onload = function () {
                            //ctx.drawImage(img, 412, 350, 95, 130);
                            ctx.drawImage(img, 180, 260, 120, 160);
                        };
                    });
                    console.log(this.stuInfo);
                    //学生姓名
                    ctx.font = "14px HYDaSongJ";
                    ctx.fillStyle = "#000";
                    ctx.fillText(`${this.stuInfo.studentName}`, 430, 295);
                    ctx.stroke();
                    // 年
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(0, 4)}`, 493, 295);
                    // 月
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(5, 7)}`, 545, 295);
                    // 日
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(8, 10)}`, 582, 295);
                    // 年
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(11, 15)}`, 635, 295);
                    // 月
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(16, 18)}`, 686, 295);
                    // 日
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(19, 21)}`, 723, 295);

                    // 下部日
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZ}`, 728, 520);

                    // 下部年
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZ}`, 635, 520);

                    // 下部月
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZ}`, 693, 520);

                    // 学时上
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText("24", 506, 379);

                    // 身份证
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.idCard}`, 208, 465);
                    // 证书编号
                    ctx.font = "13px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.certificateNum}`, 208, 503);
                }
            });
        },
        getCanvasQNJYZ() {
            var canvas = document.getElementById("canvas");
            console.log(canvas);
            var ctx = canvas.getContext("2d");
            // 绘制背景图
            var image1 = new Image();
            image1.src = this.certificateQNJYZ;
            var promise1 = new Promise((resolve, reject) => {
                image1.onload = function () {
                    ctx.drawImage(image1, 0, 0, 900, 650);
                    resolve("ok");
                };
            });
            promise1.then((res) => {
                if (res == "ok") {
                    //考生照片
                    var promise2 = new Promise((r1, r2) => {
                        var img = new Image();
                        img.crossOrigin = "*";

                        img.src = this.stuInfo.studentUrl + "?v=" + Math.random();
                        // img.src = this.person;

                        img.onload = function () {
                            //ctx.drawImage(img, 412, 350, 95, 130);
                            ctx.drawImage(img, 180, 260, 120, 160);
                        };
                    });
                    console.log(this.stuInfo);
                    //学生姓名
                    ctx.font = "14px HYDaSongJ";
                    ctx.fillStyle = "#000";
                    ctx.fillText(`${this.stuInfo.studentName}`, 430, 295);
                    ctx.stroke();
                    // 年
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(0, 4)}`, 493, 295);
                    // 月
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(5, 7)}`, 545, 295);
                    // 日
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(8, 10)}`, 582, 295);
                    // 年
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(11, 15)}`, 635, 295);
                    // 月
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(16, 18)}`, 686, 295);
                    // 日
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(19, 21)}`, 723, 295);

                    // 下部日
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZ}`, 728, 520);

                    // 下部年
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZ}`, 635, 520);

                    // 下部月
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZ}`, 693, 520);

                    // 学时上
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText("24", 428, 378);

                    // 身份证
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.idCard}`, 208, 465);
                    // 证书编号
                    ctx.font = "13px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.certificateNum}`, 208, 503);
                }
            });
        },
        getCanvasZXJYZ() {
            var canvas = document.getElementById("canvas");
            console.log(canvas);
            var ctx = canvas.getContext("2d");
            // 绘制背景图
            var image1 = new Image();
            image1.src = this.certificateZXJYZ;
            var promise1 = new Promise((resolve, reject) => {
                image1.onload = function () {
                    ctx.drawImage(image1, 0, 0, 900, 650);
                    resolve("ok");
                };
            });
            promise1.then((res) => {
                if (res == "ok") {
                    //考生照片
                    var promise2 = new Promise((r1, r2) => {
                        var img = new Image();
                        img.crossOrigin = "*";

                        img.src = this.stuInfo.studentUrl + "?v=" + Math.random();
                        // img.src = this.person;

                        img.onload = function () {
                            //ctx.drawImage(img, 412, 350, 95, 130);
                            ctx.drawImage(img, 180, 260, 120, 160);
                        };
                    });
                    console.log(this.stuInfo);
                    //学生姓名
                    ctx.font = "14px HYDaSongJ";
                    ctx.fillStyle = "#000";
                    ctx.fillText(`${this.stuInfo.studentName}`, 430, 295);
                    ctx.stroke();
                    // 年
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(0, 4)}`, 493, 295);
                    // 月
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(5, 7)}`, 545, 295);
                    // 日
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(8, 10)}`, 582, 295);
                    // 年
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(11, 15)}`, 635, 295);
                    // 月
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(16, 18)}`, 686, 295);
                    // 日
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(19, 21)}`, 723, 295);

                    // 下部日
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZ}`, 728, 520);

                    // 下部年
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZ}`, 635, 520);

                    // 下部月
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZ}`, 693, 520);

                    // 学时上
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText("16", 475, 378);

                    // 身份证
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.idCard}`, 208, 465);
                    // 证书编号
                    ctx.font = "13px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.certificateNum}`, 208, 503);
                }
            });
        },
        downloadCert() {
            var canvas = document.getElementById("canvas");
            var url = canvas.toDataURL("image/png");
            var oA = document.createElement("a");
            oA.download = this.stuInfo.studentName; // 设置下载的文件名，默认是'下载'
            oA.href = url;
            document.body.appendChild(oA);
            oA.click();
            oA.remove(); // 下载之后把创建的元素删除
        },
        downloadCertstu(downloadUrl) {
            debugger;
            // this.downloadUrl = downloadUrl;
            // if(this.userInfo.code < 0){
            //     this.showObject = {
            //         isShow: true
            //     };
            // }
            // else{
            //     window.open(downloadUrl);
            // }
            window.open(downloadUrl); window.open(downloadUrl);
        },
        getCerfityList() {
            this.$http
                .post("/api/XOrg/CertificateTypeManager/getCertificateType", {
                    isShowScore: this.type == 2 ? 1 : 0,
                    isShowCertificate: this.type == 3 ? 1 : 0,
                    type: 1,
                })
                .then((res) => {
                    if (res.code > 0) {
                        this.cerfityList = res.list;
                    } else {
                        return;
                    }
                });
        },
        toHome() {
            this.$router.push({
                name: "certifyIndex",
            });
        },
    },
};
</script>

<style lang="scss">
.new-certity-result-wrapper {
    .generic-certificate-img {
        max-width: 100%;
        max-height: 900px;
        width: auto;
        height: auto;
        cursor: pointer;
    }

    .ph-result-main {
        .generic-certificate-img {
            width: 100%;
            max-height: none;
        }
    }
}
</style>
